module.exports = __webpack_public_path__ + "img/crate4.3e83456a.png";